import Backbone from 'backbone'
import template from './range-form.hbs'
import formHelper from 'scoreboard/components/form-helper'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import FormView from 'scoreboard/components/form-view'
import _ from 'lodash'
import selects from 'scoreboard/components/selects'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import constants from 'scoreboard/components/constants'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import arrayToHash from 'scoreboard/components/array-to-hash'
import rangeKeySuffix from '../range-key-suffix'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import highlight from 'scoreboard/components/highlight'
import Dataset from 'scoreboard/datasets/model/dataset'
const { BLANK } = Dataset
import DataType from 'scoreboard/datasets/model/data-type'
const { TEXT } = DataType

function overlappingRange(ranges, low, high) {
	if (low == null) {
		low = -1 * Number.MAX_VALUE
	}
	if (high == null) {
		high = Number.MAX_VALUE
	}
	var overlap
	_.each(ranges, function(range) {
		var rangeLow = toNumber(range.low)
		if (rangeLow == null) {
			rangeLow = -1 * Number.MAX_VALUE
		}
		var rangeHigh = toNumber(range.high)
		if (rangeHigh == null) {
			rangeHigh = Number.MAX_VALUE
		}
		if (rangeLow <= low && low < rangeHigh) {
			overlap = range
			return false
		}
		if (rangeLow < high && high <= rangeHigh) {
			overlap = range
			return false
		}
	})
	if (overlap) {
		return i18n.get('datasets.fields.ranges.numeric.overlap', highlight(overlap.label))
	}
}

// converts a value into a number.  Differs from _.toNumber in how it handles
// several edge cases
function toNumber(val) {
	if (_.isNil(val) || val === '') {
		return null
	}
	return Number(val)
}

var RangeForm = Backbone.View.extend({

	/** @type {Dataset} */
	model: null,

	// this.options.field is a plain object containing the field info

	// this.options.range (optional) is a plain object containing the range info
	// (will be null when adding a new range)

	tagName: 'form',

	className: 'range-form',

	initialize: function(options) {
		this.options = options || {}
		var RangeFormFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new RangeFormFormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false
		})
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		formHelper.writeToDom(this.options.range, this.el)
		this.$('.text').toggleClass('is-not-displayed', this.options.field.dataType !== TEXT)
		this.$('.numeric').toggleClass('is-not-displayed', !isNumericDataType(this.options.field.dataType))
		this.enrichFields()
		this._toggleIncludeBlanksVisible()
		this.formView.start()
		return this
	},

	context: function() {
		var titleKey = 'datasets.fields.ranges.edit' +
			rangeKeySuffix(this.options.field.dataType)
		return {
			title: i18n.get(titleKey)
		}
	},

	// setup marked fields and the scoreboard-select
	enrichFields: function() {
		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		if (isNumericDataType(this.options.field.dataType)) {
			let options = {
				el: this.$('[name=low]'),
				evaluator: numericEvaluator,
				validator: numericValidator,
				dataType: this.options.field.dataType,
				currencyCode: this.options.field.currencyCode
			}
			this.lowField = new MarkedField(_.extend(options, {
				el: this.$('[name=low]')
			})).render()
			this.highField = new MarkedField(_.extend(options, {
				el: this.$('[name=high]')
			})).render()
		}

		if (this.options.field.dataType === TEXT) {
			// render the select without loading dots
			this.renderSelect()
			// possibly render the select with loading dots
			this.loadingTimeout = setTimeout(function() {
				this.renderSelect({
					render: {
						itemAfter: loadingDots
					}
				})
			}.bind(this), constants.LOADING_TIME)
			// render the select with all the options available once we have the data
			this.loadSelect(function(data) {
				clearTimeout(this.loadingTimeout)
				this.renderSelect({ suggestions: data })
			}.bind(this))

		}
	},

	loadSelect: function(success) {
		var selectControl = this.$('.select-control').addClass('is-loading')

		var url = 'api/datasets/' + this.model.id + '/field-values'
		if (this.options.field.id) {
			url += '?fieldId=' + this.options.field.id
		}
		$.get(url, function(values) {
			success.call(success, values)
			selectControl.removeClass('is-loading')
		})
	},

	// renders the select used for specifying text ranges
	renderSelect: function(options) {
		var suggestions = _.get(options, 'suggestions') || []
		if (suggestions) {
			// #29612 Allow "blank" as an option
			suggestions = [ BLANK ].concat(suggestions.sort())
		}

		// filter out of the suggestions any values that are already assigned
		// to other ranges
		var takenSuggestions = _.flatten(_.map(this.options.field.ranges, 'content'))
		var takenSuggestionsHash = arrayToHash(takenSuggestions)
		suggestions = _.filter(suggestions, function(suggestion) {
			return !takenSuggestionsHash[suggestion]
		})

		var suggestionsHash = arrayToHash(suggestions)

		// add any existing range content that wasn't included in the
		// suggestions
		var existingContent = _.get(this.options, 'range.content')
		if (existingContent) {
			_.each(existingContent, function(content) {
				if (!suggestionsHash[content]) {
					suggestions.push(content)
					suggestionsHash[content] = true
				}
			})
		}

		var existingContentHash = arrayToHash(existingContent)

		suggestions = _.map(suggestions, function(suggestion) {
			var selected = false
			if (existingContent) {
				selected = !!existingContentHash[suggestion]
			}
			return {
				label: _.escape(suggestion),
				value: suggestion,
				selected: selected
			}
		}.bind(this))

		let defaults = selects.defaults()
		let blankOption = `<span class="blank-value">${i18n.get('common.blank')}</span>`

		selects.filtering(this.$('select'), _.defaults({}, options, {
			multiple: true,
			// #29612 Already sorted
			sort: null,
			escapeLabels: false,
			create: function (input) {
				return {
					label: _.escape(input),
					value: input
				}
			},
			render: {
				item: function (d, input) {
					if (d.value === BLANK) {
						return blankOption
					}

					return defaults.render.item(d, input)
				},
				option: function (d, input) {
					if (d.value === BLANK) {
						return blankOption
					}

					return defaults.render.option(d, input)
				},
				create: function (d) {
					// The create new option at the bottom
					return i18n.get('common.add2', d.label)
				}
			},
			options: suggestions
		}))
	},

	_toggleIncludeBlanksVisible: function() {
		const otherRanges = this.getOtherRanges()
		const alreadyIncluded = !!otherRanges.find(it => it.includeBlank) ||
			// #40375 the blank option is for numeric fields, not text fields
			!isNumericDataType(this.options.field.dataType)
		this.$('.include-blank-container')
			.toggleClass('is-not-displayed', alreadyIncluded)
	},

	test: function(e) {
		var msg = FormView.prototype.test.apply(this, arguments)
		if (msg) {
			return msg
		}


		if (this.options.field.dataType === TEXT) {
			var content = this.$('[name=content]').val()
			if (_.isEmpty(content)) {
				return i18n.get('datasets.fields.ranges.content.required')
			}
		}

		if (isNumericDataType(this.options.field.dataType)) {
			var low = toNumber(this.$('[name=low]').val())
			var high = toNumber(this.$('[name=high]').val())

			if (low == null && high == null) {
				return i18n.get('datasets.fields.ranges.content.required')
			}

			if (low == high) {
				return i18n.get('datasets.fields.ranges.numeric.cannotEqual')
			}

			if (low != null && high != null && low > high) {
				return i18n.get('datasets.fields.ranges.numeric.wrongOrder')
			}

			// filter out the range we're currently editing from validation
			var otherRanges = this.getOtherRanges()
			return overlappingRange(otherRanges, low, high)
		}
	},

	getOtherRanges: function() {
		return _.filter(this.options.field.ranges, function(range) {
			// compare low/high b/c new ranges won't have an ID we can
			// compare
			const thisRange = this.options.range || {}
			return !(thisRange.low == range.low && thisRange.high == range.high)
		}.bind(this))
	},

	submit: function() {
		var range = formHelper.readFromDom(this.el)
		range.id = _.get(this.options, 'range.id')
		this.trigger('done', range)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.labelField, this.lowField, this.highField,
			this.formView ], 'remove')
	}

})

_.extend(RangeForm, { overlappingRange, toNumber })
export default RangeForm
export { overlappingRange }
export { toNumber }

RangeForm.__filename__ = 'datasets/edit/fields/range-form.js'
